import { createFeatureSelector } from '@ngrx/store';
import { CHECKIN_COMMON_STORE_NAME, CheckinCommonState } from './checkin-common.state';

/** Select CheckinCommon State */
export const selectCheckinCommonState = createFeatureSelector<CheckinCommonState>(CHECKIN_COMMON_STORE_NAME);
